<div class="container">
    <div class="row">
        <div class="col">
            <div style="position: absolute; z-index: 10; color: black; font-size: x-small;">
                &nbsp;&nbsp; {{getStringFromSet}}
            </div>
            <div #threeCanvas></div>
            
            <!-- prop v slider -->
            <!-- <div class="show-slider-background" (click)="showSliderForV.value = !showSliderForV.value" *ngIf="showSliderForV.value" ></div>  
            <div class="slider" [ngClass]="{ 'show': showSliderForV.value }" style="border-start-start-radius: 10px; border-bottom-left-radius: 10px;">
                <div class="slider-content">
                    <app-prop-v [showSlider]="showSliderForV" [orderDetails]="orderDetails"></app-prop-v>
                </div>  
            </div> -->

            <!-- prop a slider -->
            <!-- <div class="show-slider-background" (click)="showSliderForA.value = !showSliderForA.value" *ngIf="showSliderForA.value" ></div>  
            <div class="slider" [ngClass]="{ 'show': showSliderForA.value }" style="border-start-start-radius: 10px; border-bottom-left-radius: 10px;">
                <div class="slider-content">
                    <app-prop-a [showSlider]="showSliderForA" [toothData]="orderDetailsNew.toothData"></app-prop-a>
                </div>  
            </div> -->

            <!-- prop p slider -->
            <!-- <div class="show-slider-background" (click)="showSliderForP.value = !showSliderForP.value" *ngIf="showSliderForP.value" ></div>  
            <div class="slider" [ngClass]="{ 'show': showSliderForP.value }" style="border-start-start-radius: 10px; border-bottom-left-radius: 10px;">
                <div class="slider-content">
                    <app-prop-p [showSlider]="showSliderForP" [toothData]="orderDetailsNew.toothData"></app-prop-p>
                </div>  
            </div> -->

            <!-- prop pontic slider -->
            <!-- <div class="show-slider-background" (click)="showSliderForPontic.value = !showSliderForPontic.value" *ngIf="showSliderForPontic.value" ></div>  
            <div class="slider" [ngClass]="{ 'show': showSliderForPontic.value }" style="border-start-start-radius: 10px; border-bottom-left-radius: 10px;">
                <div class="slider-content">
                    <app-prop-pontic [showSlider]="showSliderForPontic" [toothData]="orderDetailsNew.toothData"></app-prop-pontic>
                </div>  
            </div> -->

            <!-- prop h slider -->
            <!-- <div class="show-slider-background" (click)="showSliderForH.value = !showSliderForH.value" *ngIf="showSliderForH.value" ></div>  
            <div class="slider" [ngClass]="{ 'show': showSliderForH.value }" style="border-start-start-radius: 10px; border-bottom-left-radius: 10px;">
                <div class="slider-content">
                    <app-prop-h [showSlider]="showSliderForH" [toothData]="orderDetailsNew.toothData"></app-prop-h>
                </div>  
            </div> -->

        </div>
    </div>
</div>